import { Source, OperationMode } from "./types";
import { defaultStagingURL, defaultURL } from "./constants";
let _config;
export { Source, OperationMode };
/**
 * Initializes the analytics module with the provided configuration.
 *
 * @param source - The source of the analytics events. (if source contains 'test' the call will go to the server but won't be saved.)
 * @param operationMode - The operation mode, which can be 'Prod', 'Staging', or 'Test'.
 * @param apiUrl - The base API URL to send analytics events (optional).
 */
export function init(source, operationMode, apiUrl = "") {
    let url = "";
    if (apiUrl) {
        url = apiUrl;
    }
    else {
        if (operationMode == OperationMode.Prod) {
            url = defaultURL;
        }
        else {
            url = defaultStagingURL;
        }
    }
    _config = {
        apiUrl: url,
        source,
        operationMode,
    };
}
/**
 * Sends an analytics event to the specified API URL using the provided event details.
 *
 * @param eventName - The name or type of the analytics event.
 * @param deviceName - The name of the device generating the event.
 * @param deviceId - The unique identifier of the device generating the event.
 * @param extraParams - (optional) Extra parameters for specialized events.
 * @returns A Promise that resolves to the response from the server or a test response in test mode.
 */
export function sendAnalytics(eventName, deviceName, deviceId, extraParams = {}) {
    const url = `${_config.apiUrl}/events/new`;
    const payload = JSON.stringify({
        name: eventName,
        source: _config.source,
        timestamp: Date.now() / 1000,
        device_name: deviceName,
        device_id: deviceId,
        ...extraParams,
    });
    if (_config.operationMode == OperationMode.Test) {
        const body = new Blob([payload], { type: "application/json" });
        return Promise.resolve(new Response(body));
    }
    else {
        return fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: payload,
        });
    }
}
